export default __webpack_public_path__ + "static/wayforward-4798c5f618788ebdda7cf12c952c0547.jpg";